import Text from "@components/common/Text";
import React from "react";
import { FiArrowRightCircle } from "react-icons/fi";

const TextApp = () => {
    return (
        <>
            <Text>
                Descarga iGC y colócate entre los mejores en el examen con
                nuestra aplicación de simulacros de exámenes tipo test.
                <br />
                <br />
                <ul className="mb-3 ml-0 mt-5">
                    <li>
                        <FiArrowRightCircle className="text-c1 mr-2 inline h-4 w-4" />
                        Practica lo que estás estudiando
                    </li>
                    <li>
                        <FiArrowRightCircle className="text-c1 mr-2 inline h-4 w-4" />
                        Refuerza tus puntos débiles
                    </li>
                    <li>
                        <FiArrowRightCircle className="text-c1 mr-2 inline h-4 w-4" />
                        Averigua a qué te enfrentas con exámenes reales de años
                        anteriores
                    </li>
                    <li>
                        <FiArrowRightCircle className="text-c1 mr-2 inline h-4 w-4" />
                        Practica donde y cuando quieras con tu móvil y/o tableta
                    </li>
                    <li>
                        <FiArrowRightCircle className="text-c1 mr-2 inline h-4 w-4" />
                        Amplía conocimientos de forma interactiva y dinámica
                    </li>
                </ul>
                Lengua Inglesa, Psicotécnicos, Exámenes Oficiales de años
                anteriores, etc.
                <br />
                <br />
                Haz realidad tus sueños y consigue tu plaza en la Guardia Civil.
            </Text>
        </>
    );
};

export default TextApp;
